import AtomicSDK from '@atomic.io/action-cards-web-sdk'
import { Capacitor } from '@capacitor/core'
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

export function handleRequestATT() {
  if (Capacitor.getPlatform() === 'ios') {
    AppTrackingTransparency.requestPermission().then((status) => {
      AtomicSDK.updateUser({
        profile: {
          flp_att_enabled: status.status,
        },
      })
    })
  }
}
